const terms = [
    { type: 'pattern', message: 'You must accept terms and conditions' }
]

export default {terms};